import React from 'react';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { camelize } from '../../util/string';
import { propTypes } from '../../util/types';

import FallbackPage from './FallbackPage';
import CustomLandingPageBuilder from './CustomLandingPageBuilder';
import { ASSET_NAME } from './LandingPage.duck';

export const LandingPageComponent = props => {
  const { pageAssetsData, inProgress, error, contentReady } = props;

  return (
    <CustomLandingPageBuilder
      pageAssetsData={pageAssetsData?.[camelize(ASSET_NAME)]?.data}
      inProgress={inProgress}
      error={error}
      contentReady={contentReady}
      fallbackPage={<FallbackPage error={error} />}
    />
  );
};

LandingPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
  contentReady: bool,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  const landingPageData = pageAssetsData?.[camelize(ASSET_NAME)]?.data;
  const { listingRefs = [], fetchResolved = false, fetchError = null } = state.ResaleSection || {};
  const contentReady = Boolean(error) || (Boolean(landingPageData) && (listingRefs.length > 0 || fetchResolved || fetchError));
  return { pageAssetsData, inProgress, error, contentReady };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const LandingPage = compose(connect(mapStateToProps))(LandingPageComponent);

export default LandingPage;
